import React from "react";

const FooterLanding = () => {
  return (
    <div className="flex flex-wrap justify-center m-5 mx-5 mt-5 text-center md:mx-0">
      <p className="text-[12px] mr-4 text-[#858a8f]">Meta</p>
      <p className="text-[12px] mr-4 text-[#858a8f]">Giới thiệu</p>
      <p className="text-[12px] mr-4 text-[#858a8f]">Blog</p>
      <p className="text-[12px] mr-4 text-[#858a8f]">Việc làm</p>
      <p className="text-[12px] mr-4 text-[#858a8f]">Trợ giúp</p>
      <p className="text-[12px] mr-4 text-[#858a8f]">API</p>
      <p className="text-[12px] mr-4 text-[#858a8f]">Quyền riêng tư</p>
      <p className="text-[12px] mr-4 text-[#858a8f]">Điều khoản</p>
      <p className="text-[12px] mr-4 text-[#858a8f]">
        Tài khoản liên quan nhất
      </p>
      <p className="text-[12px] mr-4 text-[#858a8f]">Vị trí</p>
      <p className="text-[12px] mr-4 text-[#858a8f]">Instagram lite</p>
      <p className="text-[12px] mr-4 text-[#858a8f]">
        Tải thông tin người liên hệ lên & người không phải người dùng
      </p>
      <p className="text-[12px] mr-4 text-[#858a8f]">Meta đã xác minh</p>
    </div>
  );
};

export default FooterLanding;
